export default __webpack_public_path__ + "static/media/mariya.55be3a06.jpg";